'use strict';

var util = require('./util');

/*
 * @param  {number} amount - The number to format.
 * @param  {string} currency - Accepts any currency from currencies file
 * @param  {object} passedOptions - Additional options for localizedCashFormat
 * @return {string} - Formatted price string
 */
module.exports = function intelligentFormat(amount, currency, passedOptions) {
    var options = util.getFormatOptions(amount, currency, passedOptions);
    return util.localizedCashFormat(amount, options);
};



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/~/dibs-currency-helpers/intelligentFormat.js
// module id = 2645
// module chunks = 62